import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { USER_LOGGED_IN } from "../Reducer/authSlice";
import NotificationSound from '../sounds/security_breach.wav';
import NotificationSound1 from '../sounds/sb.wav';
import { SOUND_ID_FETCH_START } from "../Reducer/soundIDSlice";
export default function Realtime() {

    const { user, accessToken } = useSelector((state) => state.authReducer);
    const sound_selector = useSelector((state) => state.soundReducer);
    const dispatch = useDispatch();
    const audioRef = useRef(new Audio(NotificationSound));
    const audio1 = useRef(new Audio(NotificationSound1));
    const playSoundNotification = () => {

        audioRef.current.autoplay = true;
        audioRef.current.loop = true;
        audioRef.current.play().catch(function (error) {
            console.log("Chrome cannot play sound without user interaction first")
        });
        // const audio = new Audio(NotificationSound);
        // audio.addEventListener('canplaythrough', (event) => {
        //     audio.play().catch(function (error) {
        //         console.log("Chrome cannot play sound without user interaction first")});

        // });
    };

    const pauseNotifiy = () => {
        audioRef.current.pause();
    };


    const playSoundNotificationSB = () => {

        audio1.current.autoplay = true;
        audio1.current.loop = true;
        audio1.current.play().catch(function (error) {
            console.log("Chrome cannot play sound without user interaction first")
        });

        // audio1.addEventListener('canplaythrough', (event) => {
        //     audio1.current.autoplay = true;
        //     audio1.current.loop = true;
        //     audio1.play().catch(function (error) {
        //         console.log("Chrome cannot play sound without user interaction first")
        //     });
        // });
    }

    useEffect(() => {

        if (!sound_selector?.loading) {
            audioRef.current.pause();
            // audio1.current.pause();
        }

    }, [sound_selector?.loading]);

    useEffect(() => {
        if (!user?.id || !window.Echo) return;

        console.log("Subscribing user:", user.id);

        const userChannel = window.Echo.private(`App.User.${user.id}`)
            .subscribed(() => {
                console.log(`Subscribed to App.User.${user.id}`);
            })
            .notification((notification) => {
                dispatch(SOUND_ID_FETCH_START());

                if (notification.alarm_type === 6) {
                    playSoundNotificationSB();
                } else {
                    playSoundNotification();
                }
            });

        const notifyChannel = window.Echo.channel("notify_event")
            .listen("SiteAlarmEvent", e => console.log(e))
            .listen("AccessLockAlarmCountEvent", e => console.log(e))
            .listen("RmsAlarmEvent", e => console.log(e));

        // ✅ cleanup (VERY IMPORTANT)
        return () => {
            window.Echo.leave(`private-App.User.${user.id}`);
            window.Echo.leave("notify_event");
        };

    }, [user?.id]);

    return (
        <>
        </>
    )
}